import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import { username } from '../internal.js'

const credentialTypes = [username, 'token', 'company-name'] as const

export type maniCredType = (typeof credentialTypes)[number]
export const maniDocumentTypes = [
  'proof-of-delivery',
  'signed-bol',
  'other',
  'weights-and-research-photos',
  'customs-documents',
] as const satisfies readonly DocumentType[]

export const mani: CarrierDef<maniCredType> = {
  name: 'Manitoulin Transport',
  scac: 'mani',
  credentialTypes,
  legacyCredMap: [
    ['username', 'username'],
    ['token', 'token'],
    ['company-name', 'companyName'],
  ],
  engineLayers: [
    'rating',
    'bol',
    'pickup',
    'tracking',
    'documents',
    'profinder',
  ],
  documentTypes: maniDocumentTypes,
  credentialConfig: {
    'company-name': {
      nonsensitive: true,
    },
  },
}
